import type {
  AnalyticsSimpleWidgetDataPointInput,
  AnalyticsWidgetLinkedDataPointDto,
} from "../../types/analytics/admin/AnalyticsAdminModels";

export interface SimpleWidgetAttachedDataPoint {
  key: string;
  dataPointId: number | null;
  adminName: string;
  clientFormId: number;
  clientFormName: string | null;
  scoreRef: string;
}

export function createAttachedDataPointKey(): string {
  return `dp-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function attachedFromLinked(
  item: AnalyticsWidgetLinkedDataPointDto,
): SimpleWidgetAttachedDataPoint {
  return {
    key: `linked-${item.dataPointId}`,
    dataPointId: item.dataPointId,
    adminName: item.adminName,
    clientFormId: item.clientFormId ?? 0,
    clientFormName: item.clientFormName,
    scoreRef: item.scoreRef,
  };
}

export function toDataPointInputs(
  rows: SimpleWidgetAttachedDataPoint[],
): AnalyticsSimpleWidgetDataPointInput[] {
  return rows.map((row) => ({
    dataPointId: row.dataPointId ?? undefined,
    clientFormId: row.clientFormId,
    scoreRef: row.scoreRef,
  }));
}

export function pairKey(clientFormId: number, scoreRef: string): string {
  return `${clientFormId}|${scoreRef.trim().toUpperCase()}`;
}

export function isDuplicateAttachment(
  rows: SimpleWidgetAttachedDataPoint[],
  clientFormId: number,
  scoreRef: string,
  dataPointId?: number | null,
): boolean {
  const nextPair = pairKey(clientFormId, scoreRef);
  return rows.some((row) => {
    if (dataPointId && row.dataPointId === dataPointId) {
      return true;
    }
    return pairKey(row.clientFormId, row.scoreRef) === nextPair;
  });
}

export function previewNewDataPointName(
  formName: string | null | undefined,
  clientFormId: number,
  scoreRef: string,
): string {
  const formPart = formName && formName.trim().length > 0 ? formName.trim() : String(clientFormId);
  const name = `Form ${formPart} - ${scoreRef.trim()}`;
  return name.length <= 100 ? name : name.slice(0, 100);
}
